import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import {
  CheckTextSelect,
  DemanderKbn,
  FormClassRetire,
  FormKbn,
} from "../../assets/data/Constants";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { IAPI_RET005_Request } from "../../type/apiType";
import { httpAPI_RET005 } from "./api/request";
import {
  fakeTableList,
  infoManual,
  schema,
  schema1,
  schema1_1,
  schema2,
  schema2_1,
  schema3,
  schema3_1,
  schemaAnyTime,
  retireeStepper,
  heirStepper,
  bereavedStepper,
} from "./parts";
import { API_RET005_BuildReqParams } from "../../utils/buildRequestParams";
import _ from "lodash";

/**
 * SCRR411109 退職手当金の請求手続き（本人確認書類の添付）
 * 退職手当金請求者が本人確認書類を登録する。hit
 * @return SCRR411109
 */
const SCRR411109 = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const [stateTableList, setStateTableList] = useState<any>([]);
  const [ruleSchema, setRuleSchema] = useState(schema);

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_35;
  const demanderKbn = context?.demanderKbn;
  const isRetiree = demanderKbn === DemanderKbn["退職者本人"];
  const isHeire = demanderKbn === DemanderKbn["相続人"];
  const isBeraved = demanderKbn === DemanderKbn["遺族"];
  const step = isRetiree ? 5 : 6;

  const [selectedKind, setSelectedKind] = useState("");
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  // 初期表示
  useEffect(() => {
    let resArr = stateFakeTableList.current;

    resArr.find(
      (item) => item.keyword === "identificationDocsKind"
    )!.setDefaultValue = context?.identificationDocsKind;

    context?.fileList?.forEach((item) => {
      let targetObj = resArr.find((i) => i.id === item.formClass)!;

      targetObj &&
        (targetObj.setDefaultValue = [
          {
            formName: item.fileName || item.formName,
            fileBase64: item.fileBase64 || item.file,
          },
        ]);
    });
    let identityDocs = context?.fileList?.filter(
      (item) => item.formClass === FormClassRetire["本人確認書類"]
    );
    identityDocs?.forEach((item, index) => {
      let targetObj = resArr.find(
        (i) => i.keyword === "identification" + (index + 1)
      )!;

      targetObj &&
        (targetObj.setDefaultValue = [
          {
            formName: item.fileName || item.formName,
            fileBase64: item.fileBase64 || item.file,
          },
        ]);
    });

    setSelectedKind(context?.identificationDocsKind!);
    setStateTableList([...resArr]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let resArr = [...stateFakeTableList.current];
    let identificationDocsKind = resArr.find(
      (item) => item.keyword === "identificationDocsKind"
    )!;

    identificationDocsKind.onGetValue = (e: any) => {
      setSelectedKind(e);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  // 本人確認書類の表示
  useEffect(() => {
    let resArr = [...stateFakeTableList.current];
    let identification1 = resArr.find(
      (item) => item.keyword === "identification1"
    )!;
    let identification2 = resArr.find(
      (item) => item.keyword === "identification2"
    )!;
    let identificationFront = resArr.find(
      (item) => item.keyword === "identificationFront"
    )!;
    let identificationFrontBack = resArr.find(
      (item) => item.keyword === "identificationBack"
    )!;
    let myNumberOfDeceased = resArr.find(
      (item) => item.keyword === "myNumberOfDeceased"
    )!;
    let nameConfirmation = resArr.find(
      (item) => item.keyword === "nameConfirmation"
    )!;
    let common: any = resArr.filter((_item, index) => index > 5)!;

    const isBereaved = context?.demanderKbn === DemanderKbn["遺族"];

    const isNameVisible =
      isRetiree &&
      (context?.staffNameKanji !== context?.demanderName ||
        context?.staffNameKana !== context?.demanderNameKana);

    switch (selectedKind) {
      case CheckTextSelect["個人番号カード（１２桁の番号のある面）"]:
        identification1.showLine = true;
        identification2.showLine = false;
        identificationFront.showLine = false;
        identificationFrontBack.showLine = false;
        myNumberOfDeceased.showLine = isBereaved;
        common.forEach((item: any) => {
          item.showLine = true;
        });
        const schema_1 = {
          ...(isBereaved ? schema1 : schema1_1),
        };
        if (isNameVisible) {
          setRuleSchema(schema_1 as any);
        } else {
          const { nameConfirmation, ...rest } = schema_1;
          setRuleSchema(rest as any);
        }

        break;

      case CheckTextSelect["個人番号が記載された住民票＋写真付き身分証明１点"]:
      case CheckTextSelect["通知カード＋写真付き身分証明１点"]:
        identification1.showLine = false;
        identification2.showLine = false;
        identificationFront.showLine = true;
        identificationFrontBack.showLine = true;
        myNumberOfDeceased.showLine = isBereaved;
        common.forEach((item: any) => {
          item.showLine = true;
        });

        const schema_2 = {
          ...(isBereaved ? schema2 : schema2_1),
        };
        if (isNameVisible) {
          setRuleSchema(schema_2 as any);
        } else {
          const { nameConfirmation, ...rest } = schema_2;
          setRuleSchema(rest as any);
        }

        break;

      case CheckTextSelect["個人番号が記載された住民票＋写真無し身分証明２点"]:
      case CheckTextSelect["通知カード＋写真無し身分証明２点"]:
        identification1.showLine = true;
        identification2.showLine = true;
        identificationFront.showLine = false;
        identificationFrontBack.showLine = false;
        myNumberOfDeceased.showLine = isBereaved;
        common.forEach((item: any) => {
          item.showLine = true;
        });

        const schema_3 = {
          ...(isBereaved ? schema3 : schema3_1),
        };
        if (isNameVisible) {
          setRuleSchema(schema_3 as any);
        } else {
          const { nameConfirmation, ...rest } = schema_3;
          setRuleSchema(rest as any);
        }

        break;
    }

    if (Boolean(selectedKind)) {
      nameConfirmation.showLine = isNameVisible;
    }

    setStateTableList([...resArr]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKind]);

  const makeFileObj = (obj: any) => {
    const originFileList =
      context?.fileList?.filter(
        (item) =>
          !(
            item?.formKbn === FormKbn["退職書類"] &&
            (item?.formClass === FormClassRetire["本人確認書類"] ||
              item?.formClass === FormClassRetire["本人確認書類（表面）"] ||
              item?.formClass === FormClassRetire["本人確認書類（裏面）"] ||
              item?.formClass ===
                FormClassRetire["旧姓と新姓が確認できる住民票"] ||
              item?.formClass === FormClassRetire["個人番号を確認する書類"] ||
              item?.formClass ===
                FormClassRetire["振込先口座が確認できる書類"] ||
              item?.formClass ===
                FormClassRetire["死亡した退職者の個人番号を確認する書類"])
          )
      ) ?? [];

    obj.identification1 &&
      originFileList?.push({
        fileList_staffNo: context?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["本人確認書類"],
        fileName: obj.identification1[0].formName,
        fileBase64: obj.identification1[0].fileBase64,
      });

    obj.identification2 &&
      originFileList?.push({
        fileList_staffNo: context?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["本人確認書類"],
        fileName: obj.identification2[0].formName,
        fileBase64: obj.identification2[0].fileBase64,
      });

    obj.identificationFront &&
      originFileList?.push({
        fileList_staffNo: context?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["本人確認書類（表面）"],
        fileName: obj.identificationFront[0].formName,
        fileBase64: obj.identificationFront[0].fileBase64,
      });

    obj.identificationBack &&
      originFileList?.push({
        fileList_staffNo: context?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["本人確認書類（裏面）"],
        fileName: obj.identificationBack[0].formName,
        fileBase64: obj.identificationBack[0].fileBase64,
      });

    obj.myNumberOfDeceased &&
      originFileList?.push({
        fileList_staffNo: context?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["死亡した退職者の個人番号を確認する書類"],
        fileName: obj.myNumberOfDeceased[0].formName,
        fileBase64: obj.myNumberOfDeceased[0].fileBase64,
      });

    obj.nameConfirmation &&
      originFileList?.push({
        fileList_staffNo: context?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["旧姓と新姓が確認できる住民票"],
        fileName: obj.nameConfirmation[0].formName,
        fileBase64: obj.nameConfirmation[0].fileBase64,
      });

    obj.myNumber &&
      originFileList?.push({
        fileList_staffNo: context?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["個人番号を確認する書類"],
        fileName: obj.myNumber[0].formName,
        fileBase64: obj.myNumber[0].fileBase64,
      });

    obj.bankAccount &&
      originFileList?.push({
        fileList_staffNo: context?.staffNo,
        formKbn: FormKbn["退職書類"],
        formClass: FormClassRetire["振込先口座が確認できる書類"],
        fileName: obj.bankAccount[0].formName,
        fileBase64: obj.bankAccount[0].fileBase64,
      });

    const fileList = originFileList?.map((item, index) => {
      return {
        ...item,
        serialNo: index + 1,
      };
    });

    return fileList;
  };

  const makeHttpObj = (obj: any): IAPI_RET005_Request => {
    const reqObj: IAPI_RET005_Request = {
      ...context,
      tempSaveStep: step,
      businessType: businessState.common?.businessType,
      contractorNo:
        state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
      nowZipcode: isRetiree
        ? context?.demanderZipcode
        : context?.retirementZipcode,
      nowPrefectureCd: isRetiree
        ? context?.demanderPrefectureCd
        : context?.retirementPrefectureCd,
      nowAddressCity: isRetiree
        ? context?.demanderBirth
        : context?.retirementAddressCity,
      nowAddressOthers: isRetiree
        ? context?.demanderAddressOthers
        : context?.retirementAddressOthers,
      totalPaymentAmtAfterAdd: context?.totalPaymentAmtAfterAdd,
      pastLosInCurrentYearTotalFrom: context?.totalYearLosFrom,
      pastLosInCurrentYearTotalTo: context?.totalYearLosFrom,
      pastLosInCurrentYearOtherFrom: context?.totalCurrentYearLosFrom,
      pastLosInCurrentYearOtherTo: context?.totalCurrentYearLosTo,
      contractorName: businessState.common?.contractorName,
      identificationDocsKind: obj.identificationDocsKind,
      fileList: makeFileObj(obj),
      screenId: "SCRR411109",
    };

    return API_RET005_BuildReqParams(reqObj);
  };

  const handleSubmit = async (data: any, index: any) => {
    switch (index) {
      case 0: // 一時保存
        // 退職手当金請求更新API実行
        try {
          const res = await httpAPI_RET005({
            ...makeHttpObj(data),
          });
          if (res.resultCd === "I0000") {
            setOpen(true);
            setState({ ...state, errorMsgId: "" });
            setBusinessState({
              ...businessState,
              job_35: {
                ...context,
                tempSaveStep: step,
                applyId: res.applyId,
                identificationDocsKind: data.identificationDocsKind,
                fileList: makeFileObj(data),
              },
            });
          } else {
            setState({ ...state, errorMsgId: res.resultCd });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        setBusinessState({
          ...businessState,
          job_35: {
            ...context,
            identificationDocsKind: data.identificationDocsKind,
            fileList: makeFileObj(data),
          },
        });

        // 退職者本人または相続人
        if (!isBeraved) {
          navigate("/SCRR411110");

          // 遺族
        } else {
          navigate("/SCRR410016");
        }
        break;
    }
  };
  return (
    <Box data-testid="SCRR411109test">
      <TkStepper
        steps={
          isRetiree ? retireeStepper : isHeire ? heirStepper : bereavedStepper
        }
        activeStep={step - 1}
        savaStep={context?.tempSaveStep}
      />

      <TkInfoManual rule="<">{infoManual}</TkInfoManual>

      {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="退職者名"
          no={context?.staffNameKanji!}
        />
      )}

      <TkFakeTable
        list={stateTableList}
        ruleSchema={{ ...ruleSchema, ...schemaAnyTime }}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={(e, index) => {
          handleSubmit(e, index);
        }}
      />

      <TkMessageDialog
        open={open}
        onOky={() => setOpen(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRR411109;
